import React from "react";
import { BeforeAfterColumns } from "../BeforeAfterColumns";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { afterAfter, afterBefore } from "../../data/landing";
export function Outcomes() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-248" data-mp="2vmz7klvv5p2b">
      <div className="mx-auto max-w-5xl" data-id="element-249" data-mp="2qr1ssk090qrn">
        <SectionHeading eyebrow="The transformation" title="What you should be able to do after using the system" data-id="element-250" data-mp="2qnw7lfuqq917" />
        <div className="mt-10" data-id="element-251" data-mp="3jeo6il36xbs8">
          <BeforeAfterColumns beforeTitle="Before" afterTitle="After" before={afterBefore} after={afterAfter} data-id="element-252" data-mp="3jfpkoyfi6ee6" />
        </div>
        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-navy/75" data-id="element-253" data-mp="3ee083ecmtsnz">
          The goal isn't another massive library of information. It's to help you{" "}
          <strong className="text-navy" data-id="element-254" data-mp="2317j2bb87ibm">get more value from the knowledge you already have.</strong>
        </p>
        <div className="mt-10" data-id="element-255" data-mp="1xzqk4lcay5xo">
          <CtaButton label="I want to start using the system" data-id="element-256" data-mp="1y3o233n58rfz" />
        </div>
      </div>
    </section>;
}